import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
import { endSelectionScaleTransform } from "../private/endSelectionScaleTransform.js";
import { initSelectionScaleTransform } from "../private/initSelectionScaleTransform.js";
import { progressSelectionScaleTransform } from "../private/progressSelectionScaleTransform.js";
import { ScaleTransform } from "./ScaleTransform.js";
import { TransformManipulator } from "./TransformManipulator.js";
export class ScaleTransforming2 {
  constructor({ svg_el, transform_manipulator, scale_transform }) {
    this._observer_set = new Set();
    this._svg_el = svg_el;
    this._transform_manipulator = transform_manipulator;
    this._scale_transform = scale_transform;
    this._transforming_els = [];
    this._is_started = false;
    this._start_x1 = 0;
    this._start_y1 = 0;
    this._start_x2 = 0;
    this._start_y2 = 0;
    this._origin_x = 0;
    this._origin_y = 0;
    this._x_axis_x = 0;
    this._x_axis_y = 0;
    this._y_axis_x = 0;
    this._y_axis_y = 0;
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  start({
    x1,
    y1,
    x2,
    y2,
    origin_x,
    origin_y,
    x_axis_x,
    x_axis_y,
    y_axis_x,
    y_axis_y,
    els,
  }) {
    if (this._is_started) {
      return;
      // throw new Error(`이미 진행중인 scale_transform 이 있습니다.`);
    }

    if (els.length <= 0) {
      return;
    }
    initSelectionScaleTransform({
      els,
      scale_transform: this._scale_transform,
      transform_manipulator: this._transform_manipulator,
      svg_el: this._svg_el,
    });
    this._transforming_els = els;
    this._is_started = true;
    this._start_x1 = x1;
    this._start_y1 = y1;
    this._start_x2 = x2;
    this._start_y2 = y2;
    this._origin_x = origin_x;
    this._origin_y = origin_y;
    this._x_axis_x = x_axis_x;
    this._x_axis_y = x_axis_y;
    this._y_axis_x = y_axis_x;
    this._y_axis_y = y_axis_y;
    this._notify({
      status: "START",
      matrix: this._svg_el.createSVGMatrix(),
    });
  }
  progress({ x1, y1, x2, y2 }) {
    if (!this._is_started) {
      throw new Error(`scale_transform 이 진행중이 아닙니다.`);
    }
    const x_axis_vec = {
      x: this._x_axis_x - this._origin_x,
      y: this._x_axis_y - this._origin_y,
    };
    const y_axis_vec = {
      x: this._y_axis_x - this._origin_x,
      y: this._y_axis_y - this._origin_y,
    };
    const l1 = Math.sqrt(
      (this._start_x1 - this._start_x2) ** 2 +
        (this._start_y1 - this._start_y2) ** 2
    );
    const l2 = Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
    const s = l2 / l1;
    const matrix = progressSelectionScaleTransform({
      els: this._transforming_els,
      svg_el: this._svg_el,
      sx: s,
      sy: s,
      x_axis_vec,
      y_axis_vec,
      origin_point: {
        x: this._origin_x,
        y: this._origin_y,
      },
      transform_manipulator: this._transform_manipulator,
    });
    this._notify({
      status: "PROGRESS",
      matrix,
    });
  }
  end() {
    if (!this._is_started) {
      throw new Error(`scale_transform 이 진행중이 아닙니다.`);
    }
    endSelectionScaleTransform({
      els: this._transforming_els,
      transform_manipulator: this._transform_manipulator,
    });
    this._transforming_els = [];
    this._is_started = false;
    this._start_x1 = 0;
    this._start_y1 = 0;
    this._start_x2 = 0;
    this._start_y2 = 0;
    this._origin_x = 0;
    this._origin_y = 0;
    this._x_axis_x = 0;
    this._x_axis_y = 0;
    this._y_axis_x = 0;
    this._y_axis_y = 0;
    this._notify({
      status: "END",
      matrix: this._svg_el.createSVGMatrix(),
    });
  }
  _notify(selection_transform_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(selection_transform_vo));
    }
  }
}
